import { Fragment } from "react";
import { Card, Text } from "@mantine/core";
import { useColors } from "../../../../../hooks/colors/useColors";
import { IconBuilding, IconCheckbox, IconVideo } from "@tabler/icons";
import { MyH1 } from "../../../../UI/my-h1/MyH1";
import { StepperButtons } from "./StepperButtons";
import { bookingStore } from "../../../../config/store/bookingStore";
import { useTranslation } from "next-i18next";
import { isPhone } from "../../../../../constants/env";
import { isMobile } from "react-device-detect";

export function SecondStep() {
  const { colors } = useColors();

  const { stepperFields, updateStepperFields } = bookingStore((state) => state);
  const { t } = useTranslation("common");

  function onPickOption(format: "online" | "onPremise") {
    stepperFields.format = format;
    updateStepperFields({ ...stepperFields });
  }

  const isOnPremise = stepperFields.format === "onPremise";
  let containerClass = "flex justify-center gap-4 p-4 items-center";
  if (isPhone) {
    containerClass = "flex flex-col justify-center gap-4 p-4 items-center";
  }

  return (
    <Fragment>
      <div className="m-4 mb-16">
        <MyH1 centerText size="3rem">
          {t("appointments.pickFormat")}
        </MyH1>
      </div>
      <div className={containerClass}>
        <Card
          radius="lg"
          onClick={() => onPickOption("onPremise")}
          className="flex justify-center items-center hover"
          style={{
            border:
              stepperFields.format === "onPremise"
                ? `5px solid ${colors.success}`
                : undefined,
            padding: isOnPremise ? "5px" : undefined,
            opacity: isOnPremise ? undefined : 0.6,
            // height: isPhone ? "22rem" : "30rem",
            // width: isPhone ? "22rem" : "30rem",
          }}
        >
          <Card
            radius="lg"
            style={{
              backgroundColor: colors.success,
            }}
            className="flex flex-col justify-center items-center gap-4 h-full w-full"
          >
            <div className="flex gap-4 items-center justify-center">
              {isOnPremise && (
                <IconCheckbox stroke={2} size="4rem" color="white" />
              )}
              <IconBuilding color="white" size="4rem" stroke={1} />
              <Text
                className={
                  isMobile
                    ? "!text-4xl font-bold !text-white"
                    : "!text-5xl font-bold !text-white"
                }
              >
                {t("appointments.onPremise")}
              </Text>
            </div>
          </Card>
        </Card>
        <Card
          onClick={() => onPickOption("online")}
          radius="lg"
          style={{
            border:
              stepperFields.format === "online"
                ? `5px solid ${colors.secondary}`
                : undefined,
            padding: !isOnPremise ? "5px" : undefined,
            opacity: !isOnPremise ? undefined : 0.6,
            // height: isPhone ? "22rem" : "30rem",
            // width: isPhone ? "22rem" : "30rem",
          }}
          className="flex justify-center items-center hover"
        >
          <Card
            radius="lg"
            style={{
              backgroundColor: colors.secondary,
            }}
            className="flex flex-col justify-center items-center gap-4 h-full w-full"
          >
            <div className="flex gap-4 items-center justify-center">
              {!isOnPremise && (
                <IconCheckbox stroke={2} size="4rem" color="white" />
              )}
              <IconVideo
                color="white"
                size="4rem"
                className="!text-white"
                stroke={1}
              />
              <Text
                className={
                  isMobile
                    ? "!text-4xl font-bold !text-white"
                    : "!text-5xl font-bold !text-white"
                }
              >
                {t("appointments.online")}
              </Text>
            </div>
          </Card>
        </Card>
      </div>
      <StepperButtons />
    </Fragment>
  );
}
